import { motion } from "framer-motion";
import { Clock, ShieldCheck, ArrowRight } from "lucide-react";
import { useI18n } from "../i18n";

export const Payment = ({ onQuote }) => {
  const { t } = useI18n();
  return (
    <section id="reserver" data-testid="payment-section" className="relative py-28 md:py-36 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="font-mono-accent text-xs uppercase tracking-[0.3em] text-cyan">{t("payment.tag")}</span>
            <div className="flex items-center gap-3 mt-4 flex-wrap">
              <h2 className="font-display font-700 uppercase tracking-tighter text-4xl md:text-6xl leading-none">
                {t("payment.title1")} <span className="text-cyan neon-text-glow">{t("payment.title2")}</span>
              </h2>
              <span
                data-testid="prelaunch-booking-badge"
                className="inline-flex items-center gap-2 rounded-full border border-cyan-400/40 bg-cyan-400/10 px-3 py-1 font-mono-accent text-[10px] uppercase tracking-[0.2em] text-cyan"
              >
                <Clock size={12} /> {t("preLaunch.badge")}
              </span>
            </div>
          </div>
          <p className="max-w-md text-neutral-400 font-light">{t("payment.subtitle")}</p>
        </div>

        <motion.div
          data-testid="prelaunch-booking-placeholder"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-3xl border border-cyan-500/25 bg-gradient-to-br from-[#0F1115] to-[#070809] p-10 md:p-16 text-center"
        >
          <div className="absolute inset-0 radial-cyan pointer-events-none opacity-60" />

          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full border border-cyan-400/40 bg-cyan-400/10 px-4 py-2 font-mono-accent text-[10px] uppercase tracking-[0.25em] text-cyan">
              <Clock size={12} /> {t("preLaunch.badge")}
            </div>

            <h3 className="font-display font-700 uppercase tracking-tight text-3xl md:text-5xl mt-6 leading-tight max-w-3xl mx-auto">
              {t("preLaunch.bookingsDisabled")}
            </h3>

            <p className="text-neutral-400 font-light mt-5 max-w-xl mx-auto">
              {t("preLaunch.bookingsHint")}
            </p>

            <button
              data-testid="prelaunch-booking-cta"
              onClick={onQuote}
              className="mt-8 inline-flex items-center gap-3 text-black font-medium text-sm px-7 py-3.5 rounded-full neon-glow hover:scale-[1.03] active:scale-95 transition-transform duration-300"
              style={{ backgroundColor: "#C9A96A" }}
            >
              {t("payment.custom.cta")} <ArrowRight size={16} />
            </button>

            <div className="mt-8 inline-flex items-center gap-2 text-neutral-500 font-mono-accent text-xs uppercase tracking-widest">
              <ShieldCheck size={15} className="text-cyan" /> {t("payment.securedBy")}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
